/**
 * Customer type enum values
 */
export enum CustomerType {
  PERSON = 'person',
  COMPANY = 'company',
}
